import { inject, Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';
import { UserService } from '../services/user.service';
import { AuthStore } from './auth.store';
import { Stores } from '../../api/services/stores';
import { Router } from '@angular/router';

//TODO generate swagger types
//export type User = components['schemas']['UserViewModel'];

@Injectable({
  providedIn: 'root',
})
export class UserAuthService {
  authStore = inject(AuthStore);

  constructor(
    public router: Router,
    private userService: UserService,
    private stores: Stores
  ) {
    if (this.authStore.jwtSignal && this.authStore.jwtSignal()) {
      this.loadUserDetails();
    }
  }

  loadUserDetails() {
    if (!this.authStore.jwtSignal()) {
      this.authStore.setUser(null);
      this.authStore.setUserIsLoggedIn(false);
      return;
    }

    if (this.authStore.userSignal && this.authStore.userSignal()) {
      return;
    }

    this.authStore.setLoading(true);
    this.userService.getUser().pipe(
      catchError((error) => {
        this.authStore.setLoading(false);
        return of(false);
      })
    ).subscribe({
      next: (user:any) => {
        this.authStore.setLoading(false);
        if (!user) {
          this.logout();
          return;
        }
        this.authStore.setJwt(window.localStorage.getItem('token'));
        this.authStore.setUser(user);
        this.authStore.setUserIsLoggedIn(true);
      }
    });
  }

  public logout() {
    window.localStorage.removeItem('token');
    this.stores.resetStores();
    this.router.navigate(['/login']);
  }

  get isLoggedIn() {
    return this.authStore;
  }

  public userHasRole(role: string): boolean {

    if (this.authStore.userSignal) {
      const store = this.authStore.userSignal() ?? {};
      if (!store || !store.roles) {
        return false;
      }
      return store.roles.includes(role);
    }

    return false;
  }
}
